<div class="white-box-row ai-entity-tokens">
  <div class="white-box-header">
    <div class="medium-title fl-l">
      {{ "AI_TOKENS.TITLE" | translate }}
    </div>
    <div
      class="white-box-header-action orange fl-r edit-info"
      (click)="openCreate()"
    >
      <i class="icon-add"></i>
      <span class="fw-700">
        {{ "AI_TOKENS.ADD_QUOTA" | translate }}
      </span>
    </div>
  </div>
  <div class="clear"></div>

  <div class="white-box-body">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

    <section class="quotas">
      <table mat-table [dataSource]="quotas" *ngIf="quotas.length">
        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef>
            {{ "AI_TOKENS.PERIOD" | translate }}
          </th>
          <td mat-cell *matCellDef="let q">{{ q.period }}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>
            {{ "AI_TOKENS.LIMIT" | translate }}
          </th>
          <td mat-cell *matCellDef="let q">
            {{ centsToDollars(q.maxCostCents) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let q">
            <button
              mat-icon-button
              (click)="openEdit(q)"
              [attr.aria-label]="'GENERALS.EDIT' | translate"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="['period', 'amount', 'actions']"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['period', 'amount', 'actions']"
        ></tr>
      </table>
      <p class="empty-state" *ngIf="!quotas.length">
        {{ "AI_TOKENS.NO_QUOTAS" | translate }}
      </p>
    </section>
  </div>
</div>
